
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    DialogIndex: Number,
    DialogData: { default: () => { return {} }, type: Object as PropType<DialogData> }
  },
  data () {
    return {
      OriginalData: {} as any,
      Saving: false,
      Loading: [] as Array<'Loading'>,
      Profiles: [],
      ErrorsVisibilty: false,
      DialogMapper: [
        { Path: 'Name', Res: 'D_User_Name' },
        { Path: 'Email', Res: 'D_User_Email' },
        { Path: 'Password', Res: 'D_User_Password' },
        { Path: 'Profile', Res: 'D_User_Profile', ValuePath: 'ID' },
        { Path: 'ImgUrl', Res: 'D_User_ImgUrl', IsImage: true, Default: '' }
      ] as Array<DialogMapperObject>
    }
  },
  methods: {
    ReadDialogData () {
      this.ReadProfiles()
    },
    ReadProfiles () {
      this.Loading.push('Loading')
      this.Get('Security_Profiles').then(response => {
        this.Profiles = response
        this.Loading.shift() // Remove Loading flag
      }, error => {
        this.Loading.shift() // Remove Loading flag
        error.CookiesError = 'Error in reading Profiles'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    SaveData () {
      this.SaveDialogData({
        DialogMapper: this.DialogMapper,
        Parentthis: this,
        PostAPI: 'Security_Users',
        OriginalData: this.OriginalData,
        PatchAPI: 'Security_Users',
        Editing: this.DialogData.Editing,
        PatchQuery: this.DialogData.Editing ? '?ID=' + this.DialogData.Data.ID : ''
      })
    },
    DataSaved () {
      console.log('ssssssssssss')
      this.Saving = false
      this.$router.go(-1)
    },
    ChangePassword () {
      this.OpenDialog('Security_ChangePassword_Dialog', 'Change Password', this.MEMRead('D_User_Email')) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    PrintTable () {
      const TableDom = document.getElementById('D_Profiles_Roles_Table')
      this.PrintIT(TableDom)
    }
  },
  created () {
    if (this.DialogData.Editing) {
      this.OriginalData = this.CookiesDialogInitiator(this.DialogMapper, this.DialogData.Data)
    }
  },
  mounted () {
    if (this.DialogData.Editing) {
      this.OriginalData = this.CookiesDialogInitiator(this.DialogMapper, this.DialogData.Data)
    }
    this.ReadDialogData()
    const Dialog = document.getElementById('CookiesDialog_' + this.DialogIndex)
    if (Dialog) {
      window.scrollTo(0, Dialog.offsetTop - 60)
    }
  }
})
